import { useMemo } from 'react';
import { useCampaignSettings } from '../../../../../state/CampaignSettings/hooks/useCampaignSettings';

export const useShowRevertToDraftBanner = () => {
  const { status } = useCampaignSettings();
  return useMemo(() => status === 'Test' || status === 'Live', [status]);
};
